import React from 'react'
import styled from '@emotion/styled'
import { Flex, Icon, BoxHeadline, Button, Label, SUI } from 'shared/ui'
import ProgressBar from './ProgressBar'

const MergeIcon = styled(({ swapped, ...rest }) => (
  <Icon name="merge" {...rest} />
))`
  transform: ${({ swapped }) => swapped && 'rotate(180deg)'};
`

const CenteredBox = styled('div')`
  text-align: center;
`

export const ConfirmPane = ({
  childTickets,
  className,
  confirmationSeconds,
  direction,
  onCancel,
  targetTicket,
}) => {
  return (
    <div className={className}>
      <SUI>
        <Flex className="grui mt-12 items-center flex-col">
          {childTickets.map(ticket => (
            <CenteredBox className="grui mx-12" key={ticket.id}>
              <BoxHeadline color="gray">{ticket.title}</BoxHeadline>
            </CenteredBox>
          ))}
          <Flex className="grui mt-10">
            <MergeIcon
              color="color.monochrome.white"
              swapped={direction !== 'normal'}
            />
            <Label
              className="grui ml-10"
              size="large"
              style={{ lineHeight: '1.85' }}
            >
              merging into
            </Label>
          </Flex>
          <CenteredBox className="grui mt-10 mx-12">
            <BoxHeadline>{targetTicket.title}</BoxHeadline>
          </CenteredBox>

          <ProgressBar className="grui mt-10" duration={confirmationSeconds} />

          <Button basic className="grui mt-12" onClick={onCancel}>
            Cancel Merge
          </Button>
        </Flex>
      </SUI>
    </div>
  )
}

export default styled(ConfirmPane)`
  min-height: 360px;
`
